export function About(): JSX.Element {
  return (
    <article>
      <h1 className="text-[28px] font-semibold text-ink mb-2">关于我们</h1>
      <p className="text-ink-muted mb-10">哪都通是什么，为什么做这件事。</p>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">我们是谁</h2>
        <div className="space-y-3 text-[14px] text-ink-muted leading-relaxed">
          <p>
            哪都通是一个面向中国开发者的 AI 模型网关平台。我们将海外顶级大模型（Claude、GPT 等）通过自建的全球网络接入国内，让开发者无需翻墙、无需信用卡，就能以人民币按量使用世界一流的 AI 能力。
          </p>
          <p>
            我们不做模型训练，不做数据标注，也不做 AI 应用——我们只做一件事：<strong className="text-ink">让模型的调用链路稳定、快速、便宜</strong>。
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">为什么选择哪都通</h2>
        <div className="space-y-4 text-[14px] text-ink-muted leading-relaxed">
          <div className="rounded-xl bg-butter/40 p-5">
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-claude font-bold text-[16px] mt-0.5">1:1</span>
                <div>
                  <strong className="text-ink">协议完全兼容</strong>
                  <p className="mt-0.5">Anthropic API 原生协议，请求和响应一字不差。不是"兼容模式"，是真正的透传。所有 SDK、工具、框架零改动直接切换。</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-claude font-bold text-[16px] mt-0.5">¥</span>
                <div>
                  <strong className="text-ink">人民币结算，低至 1 折起</strong>
                  <p className="mt-0.5">无需国际信用卡。多渠道灵活定价，不同渠道折扣不同，最低可达官方价格的 12%。按实际用量扣费，没有套餐锁定。</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-claude font-bold text-[16px] mt-0.5">⚡</span>
                <div>
                  <strong className="text-ink">多渠道智能路由</strong>
                  <p className="mt-0.5">同一模型可通过多条渠道供应。网关自动选择最优上游，平衡成本与速度。单条渠道故障不影响你的服务。</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-claude font-bold text-[16px] mt-0.5">🔒</span>
                <div>
                  <strong className="text-ink">不碰你的数据</strong>
                  <p className="mt-0.5">我们是网关，不是代理。请求全程透传到上游模型厂商，不缓存内容、不记录对话、不做任何数据加工。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">技术架构</h2>
        <div className="space-y-3 text-[14px] text-ink-muted leading-relaxed">
          <p>
            哪都通运行在 Cloudflare 全球边缘网络上，所有核心组件（网关、计费、控制台）都是 Cloudflare Workers + D1，无传统服务器、无冷启动。全球 300+ 节点就近接入，首字节延迟通常在 50ms 以内。
          </p>
          <p>
            计费系统采用后扣费模式——请求先完成，再根据实际 Token 消耗扣款。扣费幂等（同一请求不会重复扣款），余额不足时拒绝新请求而非产生欠费。
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">联系我们</h2>
        <div className="text-[14px] text-ink-muted leading-relaxed">
          <p>
            技术支持与商务合作：<a href="mailto:support@nadoutong.org" className="text-claude hover:underline">support@nadoutong.org</a>
          </p>
        </div>
      </section>
    </article>
  );
}
